import { Injectable } from '@angular/core';
import { Item } from 'src/app/core/models/item.model';
import { AngularFireDatabase } from '@angular/fire/database';
import { map } from 'rxjs/operators';
import { IGift, IUser } from 'src/app/core/models/user.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RestService {

  private readonly PATH = environment.rotaCasal;

  constructor(
    private db: AngularFireDatabase
    ) { }

  getUser() {
    return this.db.list(`${this.PATH}/users`)
    .snapshotChanges()
    .pipe(
      map(changes => {
        return changes.map(item => ({ key: item.payload.key, ...item.payload.exportVal() }));
      })
    );
  }

  getUserHistoric() {
    return this.db.list(`${this.PATH}/users_historic`)
    .snapshotChanges()
    .pipe(
      map(changes => {
        return changes.map(item => ({ key: item.payload.key, ...item.payload.exportVal() }));
      })
    );
  }

  addUser(userData: any): Promise<any> {
    return new Promise(resolve => {
      resolve(this.db.list(`${this.PATH}/users`).push(userData));
    });
  }

  setUserHistoric(userData: any): void {
    this.db.list(`${this.PATH}/users_historic`).push(userData)
    .then((result: any) => {
      // console.log(result.key);
    });
  }

    getAdmUser() {
      return this.db.list(`${this.PATH}/adm`)
      .snapshotChanges()
      .pipe(
        map(changes => {
          return changes.map(item => ({ key: item.payload.key, ...item.payload.exportVal() }));
        })
      );
    }

  setAdmUser(credential: any): void {
    this.db.list(`${this.PATH}/adm`).push(credential)
    .then((result: any) => {
    });
  }

  clonarItens(caminhoReferencia: string): void {
    this.getItems(caminhoReferencia).subscribe((itensList) => {
      itensList.forEach(item => {
        delete item.key;
        this.setItem(item);
      });
    });
  }

  getItems(backupPath?: string) {
    const path = backupPath ? `${backupPath}/item` : `${this.PATH}/item`;
    console.log('path: ', path);
    
    return this.db.list(path)
    .snapshotChanges()
    .pipe(
      map(changes => {
        return changes.map(item => ({ key: item.payload.key, ...item.payload.exportVal() }));
      })
    );
  }

  setItem(item: Item): void {
    this.db.list(`${this.PATH}/item`).push(item)
    .then((result: any) => {
      // console.log(result.key);
    });
  }

  updateItem(item: IGift, key: string, isRemove?: boolean): void {
    if (!this.isLimitReached(item)) {
      if (!isRemove) {
        item.confirmedQuantity++;
      }

      if (this.isLimitReached(item)) {
        item.status = false;
      }
    }
    this.db.list(`${this.PATH}/item`).update(key, item);
  }
  
  // Zera todas as quantidades
  resetItems(item: Item, key: string) { // colocar PATH**********************************
    this.db.list('item').update(key, item);
  }

  deleteItem(key: string) {
    this.db.object(`${this.PATH}/item/${key}`).remove();
  }

  //Zera todos os usuários
  resetUsers(key: string) {
    this.db.object(`${this.PATH}/users/${key}`).remove();
  }

  private isLimitReached(item: Item): boolean {
    return (item.limitQuantity !== 0 && item.confirmedQuantity !==0) && item.limitQuantity === item.confirmedQuantity;
    // return item.limitQuantity === item.confirmedQuantity;
  }

  getAlert() {
    return this.db.list(`${this.PATH}/alert`)
    .snapshotChanges()
    .pipe(
      map(changes => {
        return changes.map(alert => ({ key: alert.payload.key, ...alert.payload.exportVal() }));
      })
    );
  }

  setAlert(alertContent): void {
    this.db.list(`${this.PATH}/alert`).push(alertContent)
    .then((result: any) => {
      return result.key;
    });
  }

  updateAlert(alertContent, key: string): void {
    this.db.list(`${this.PATH}/alert`).update(key, alertContent);
  }

  updateUser(key: string, userData: IUser): void {
    this.db.list(`${this.PATH}/users`).update(key, userData);
  }

  getCoupleData() {
    return this.db.list(`${this.PATH}/couple_data`)
    .snapshotChanges()
    .pipe(
      map(changes => {
        return changes.map(item => ({ key: item.payload.key, ...item.payload.exportVal() }));
      })
    );
  }

  setCoupleData(data: any): void {
    this.db.list(`${this.PATH}/couple_data`).push(data)
    .then((result: any) => {
      // console.log(result.key);
    });
  }

  updateCoupleData(data: any, key: string): void {
    this.db.list(`${this.PATH}/couple_data`).update(key, data);
  }
}
